import { User } from '../../../models/User'
import { Option } from 'react-multi-select-component'

export interface UserOption extends Option {
  email: string
  crossAccount: boolean
}

const resolveUserName = (user: User) => {
  const first_last = [user.firstName, user.lastName].filter((i) => i).join(' ')
  const name = user.name
  return name && name !== user.email ? name : first_last || user.email
}

export const userToUserOption = (user: User): UserOption => ({
  value: user.id,
  key: user.id,
  label: `${resolveUserName(user)}`,
  email: user.email,
  crossAccount: user.type === 'cross-account',
})

export const sortUserOptionsBySelected = (options: UserOption[], selectedIds: string[]) => {
  const selected = new Set(selectedIds)
  return [...options.filter((o) => selected.has(o.value)), ...options.filter((o) => !selected.has(o.value))]
}
